import { createContext } from "react";
const ThemeContext = createContext({
  preset: null
});
const ThemeProvider = ThemeContext.Provider;
const ThemeConsumer = ThemeContext.Consumer;
export {
  ThemeConsumer,
  ThemeContext,
  ThemeProvider
};
